import { useEffect, useState } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import AppLoading from 'containers/App/AppLoading'
import AppTheme from 'containers/App/AppTheme'
import globalStore from 'store'
import { IResponsePlan } from 'models/response.plan.model'
import Services from 'services'

const ProtectByResponsePlan = () => {
  const loggedOutResponsePlan = globalStore(state => state.loggedOutResponsePlan)
  const [isLoadingState, setIsLoadingState] = useState(true)
  const [responsePlan, setResponsePlan] = useState<IResponsePlan | undefined>(undefined)

  useEffect(() => {
    if (loggedOutResponsePlan) return

    const getResponsePlan = async () => {
      Services.ResponsePlan.getResponsePlan()
        .then(response => {
          setResponsePlan(response)
        })
        .finally(() => {
          setIsLoadingState(false)
        })
    }
    getResponsePlan()
  }, [loggedOutResponsePlan])

  if (loggedOutResponsePlan) return <Outlet />

  if (isLoadingState) {
    return (
      <AppTheme>
        <AppLoading />
      </AppTheme>
    )
  }

  return responsePlan ? <Outlet /> : <Navigate to="/" />
}

export default ProtectByResponsePlan
